var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.75,
    height: 22,
    viewBox: "0 0 24.75 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_4595",
    "data-name": "Path 4595",
    d: "M-.666-19.005a1.028,1.028,0,0,1,1.332,0L12.01-9.38a1.029,1.029,0,0,1,.12,1.452,1.029,1.029,0,0,1-1.452.12L9.625-8.7V-.687A3.437,3.437,0,0,1,6.188,2.75H-6.187A3.437,3.437,0,0,1-9.625-.687V-8.7l-1.051.894a1.031,1.031,0,0,1-1.454-.12,1.03,1.03,0,0,1,.119-1.452Zm-6.9,8.555V-.687A1.374,1.374,0,0,0-6.188.688H6.188A1.374,1.374,0,0,0,7.563-.687V-10.45L0-16.867Z",
    transform: "translate(12.375 19.25)",
    fill: "#707070"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.140bbdc481bbef37fe3150fb268aa28c.svg";
export { ForwardRef as ReactComponent };